const GA_ID = process.env.REACT_APP_GA4_ID;
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;

let initialized = false;

export const initAnalytics = () => {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: true });
  }

  if (CLARITY_ID) {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_ID);
  }
};

export const track = (event, params = {}) => {
  if (typeof window === "undefined") return;
  try {
    if (window.gtag && GA_ID) {
      window.gtag("event", event, params);
    }
    if (window.clarity && CLARITY_ID) {
      window.clarity("event", event);
    }
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.debug("[analytics]", event, params);
    }
  } catch (e) {
    // ignore
  }
};

export const trackPageView = (path) => {
  if (typeof window === "undefined") return;
  try {
    if (window.gtag && GA_ID) {
      window.gtag("event", "page_view", { page_path: path });
    }
  } catch (e) {
    // ignore
  }
};
